import { allMonitorTypes, MonitorType } from '../../../shared/types/monitor/MonitorType';
import { getMonitorName } from '../../../shared/helpers/MonitorTypeHelpers';

export interface MarketplaceModel {
  name: string;
  /** Every monitor type sold under this name (e.g. GPT = the browser and the API variant). */
  monitorTypes: MonitorType[];
}

/**
 * Models the account can still buy: the monitor types of `allMonitorTypes` grouped by their display name, minus
 * every group the account already has a type of in `features` — one GPT variant means GPT is already there.
 */
export const missingModels = (features: MonitorType[]): MarketplaceModel[] => {
  const groups = new Map<string, MonitorType[]>();
  for (const type of allMonitorTypes as MonitorType[]) {
    const name = getMonitorName(type);
    if (!name) continue;
    groups.set(name, [...(groups.get(name) ?? []), type]);
  }
  return Array.from(groups.entries())
    .filter(([, types]) => !types.some((type) => features.includes(type)))
    .map(([name, monitorTypes]) => ({ name, monitorTypes }));
};
